export default __webpack_public_path__ + "static/media/hover_edit_icon.196c443f.svg";